// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__oKB42","select":"Header_select__gCXX6","clinic":"Header_clinic__3RDtX"};